(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3695],{

/***/ 53265:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_sites/[appId]/[...slug]",
      function () {
        return __webpack_require__(59387);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ DynamicSlugPage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(40549);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2734);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72575);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61582);
/* harmony import */ var _sections_landing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82290);
/* harmony import */ var _utils_common__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(20474);
/* harmony import */ var _services_pageRender__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28285);
/* harmony import */ var _hooks_useApp__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28821);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);












// ----------------------------------------------------------------------
var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)("div")(function() {
    return {
        height: "100%"
    };
});
var ContentStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return {
        overflow: "hidden",
        position: "relative",
        backgroundColor: theme.palette.background.default
    };
});
// ----------------------------------------------------------------------
DynamicSlugPage.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
// ----------------------------------------------------------------------
function DynamicSlugPage(param) {
    var title = param.title, sections = param.sections, seoMetadataItemsCollection = param.seoMetadataItemsCollection, globalSetting = param.globalSetting, tags = param.tags;
    var ref, ref1;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)();
    var query = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)().query;
    var slug = query.slug;
    var ref2;
    var pageSlug = Array.isArray(slug) ? slug : (ref2 = (ref = slug === null || slug === void 0 ? void 0 : slug.split("/")) === null || ref === void 0 ? void 0 : ref.slice(1)) !== null && ref2 !== void 0 ? ref2 : [];
    var ref3 = (0,_hooks_useApp__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(), logo = ref3.logo, host = ref3.host, rootTitle = ref3.title, rootDescription = ref3.description, sectionColors = ref3.sectionColors;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(sectionColors !== null && sectionColors !== void 0 ? sectionColors : [], 2), colorFirst = ref4[0], colorSection = ref4[1];
    var pageUrl = "https://".concat(host).concat("/" + (pageSlug === null || pageSlug === void 0 ? void 0 : pageSlug.join("/")));
    var description = (ref1 = lodash_find__WEBPACK_IMPORTED_MODULE_6___default()(seoMetadataItemsCollection, {
        name: "description"
    })) === null || ref1 === void 0 ? void 0 : ref1.content;
    var sectionBackgroundColors = [
        colorFirst !== null && colorFirst !== void 0 ? colorFirst : theme.palette.background.neutral,
        colorSection !== null && colorSection !== void 0 ? colorSection : theme.palette.background.default, 
    ];
    var heroSection = sections === null || sections === void 0 ? void 0 : sections.find(function(section) {
        return section.key === "SectionsHero";
    });
    var ref5;
    var sectionComponents = (ref5 = sections === null || sections === void 0 ? void 0 : sections.map(function(section, index) {
        return (0,_services_pageRender__WEBPACK_IMPORTED_MODULE_4__/* .renderComponent */ .S)(section, sectionBackgroundColors, index, globalSetting);
    }).filter(_utils_common__WEBPACK_IMPORTED_MODULE_11__/* .notEmpty */ .D)) !== null && ref5 !== void 0 ? ref5 : [];
    var ref6, ref7;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        title: title !== null && title !== void 0 ? title : "",
        metadataItems: seoMetadataItemsCollection,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "WebPage",
            name: (ref6 = title !== null && title !== void 0 ? title : rootTitle) !== null && ref6 !== void 0 ? ref6 : "",
            url: pageUrl,
            "@id": pageUrl,
            description: (ref7 = description !== null && description !== void 0 ? description : rootDescription) !== null && ref7 !== void 0 ? ref7 : "",
            publisher: {
                "@type": "Organization",
                name: rootTitle !== null && rootTitle !== void 0 ? rootTitle : "",
                logo: {
                    "@type": "ImageObject",
                    url: logo !== null && logo !== void 0 ? logo : ""
                }
            }
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(RootStyle, {
            children: [
                (heroSection === null || heroSection === void 0 ? void 0 : heroSection.key) === "SectionsHero" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sections_landing__WEBPACK_IMPORTED_MODULE_3__/* .LandingHero */ .Ks, {
                    contentfulDataFragment: heroSection,
                    contentfulDataForProductSearchTagsFragment: tags
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ContentStyle, {
                    children: sectionComponents
                })
            ]
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4885,3662,6547,513,9694,1664,9463,7952,4894,1997,2679,2077,5644,6894,5564,285,2219,5609,2454,9452,3365,8424,6755,3907,2575,8727,8285,9774,2888,179], function() { return __webpack_exec__(53265); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);